import { render, staticRenderFns } from "./GreenLabel.vue?vue&type=template&id=9919f022&"
import script from "./GreenLabel.vue?vue&type=script&lang=js&"
export * from "./GreenLabel.vue?vue&type=script&lang=js&"
import style0 from "./GreenLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports